import type { Recipe, RecipeDraft, RecipeFilters } from "../types";
import { createClientId } from "./id";

export function totalMinutes(recipe: Pick<Recipe, "prepMinutes" | "cookMinutes">) {
  return recipe.prepMinutes + recipe.cookMinutes;
}

export function filterRecipes(recipes: Recipe[], filters: RecipeFilters) {
  const query = filters.query.trim().toLocaleLowerCase("fr");
  return recipes.filter((recipe) => {
    const searchable = [
      recipe.title,
      recipe.description,
      recipe.author.displayName,
      ...recipe.categories,
      ...recipe.ingredients.map((item) => item.name),
    ]
      .join(" ")
      .toLocaleLowerCase("fr");
    return (
      (!query || searchable.includes(query)) &&
      (filters.author === "Tous" || recipe.author.id === filters.author) &&
      (filters.category === "Toutes" || recipe.categories.includes(filters.category)) &&
      (filters.maxDuration === null || totalMinutes(recipe) <= filters.maxDuration) &&
      (filters.visibility === "all" || recipe.visibility === filters.visibility)
    );
  });
}

export function validateRecipe(draft: RecipeDraft) {
  const errors: Record<string, string> = {};
  if (draft.title.trim().length < 3) errors.title = "Ajoutez un titre d’au moins 3 caractères.";
  if (draft.servings < 1) errors.servings = "Indiquez au moins une portion.";
  if (draft.prepMinutes < 0 || draft.cookMinutes < 0) errors.time = "Les durées ne peuvent pas être négatives.";
  if (!draft.ingredients.length) errors.ingredients = "Ajoutez au moins un ingrédient.";
  if (draft.ingredients.some((item) => !item.name.trim())) errors.ingredients = "Chaque ingrédient doit avoir un nom.";
  if (!draft.steps.length) errors.steps = "Ajoutez au moins une étape.";
  if (draft.steps.some((item) => !item.instruction.trim())) errors.steps = "Chaque étape doit avoir une instruction.";
  return errors;
}

export function reorder<T extends { position: number }>(items: T[], index: number, direction: -1 | 1) {
  const destination = index + direction;
  if (destination < 0 || destination >= items.length) return items;
  const copy = [...items];
  const current = copy[index];
  const target = copy[destination];
  if (!current || !target) return items;
  copy[index] = target;
  copy[destination] = current;
  return copy.map((item, position) => ({ ...item, position }));
}

export function emptyDraft(): RecipeDraft {
  return {
    title: "",
    description: "",
    categories: [],
    servings: 4,
    prepMinutes: 10,
    cookMinutes: 0,
    visibility: "private",
    sharedGroupIds: [],
    sharedUserIds: [],
    ingredients: [{ id: createClientId(), name: "", quantity: "", unit: "", note: "", position: 0 }],
    steps: [{ id: createClientId(), instruction: "", position: 0 }],
  };
}
